import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";

export const useAIFeaturesEnabled = () => {
  const { organization } = useCurrentUserContext();

  return {
    isAIFeaturesEnabled: Boolean(organization?.npoContext),
  };
};
